import { FC } from 'react'
import { composeClasses } from '@/utils/compose-classes'
import { MdOutlineExpandLess, MdOutlineExpandMore } from 'react-icons/md'

export interface TriggerButtonProps {
  value?: string | number
  placeholder?: string
  isOpen: boolean
}

export const _TriggerButton: FC<TriggerButtonProps> = ({
  isOpen,
  placeholder,
  value
}) => {
  return (
    <div
      data-testid="trigger-button"
      className={composeClasses(
        isOpen
          ? 'border-2 border-button-dark'
          : 'border-surface-strokes hover:bg-surface-gray-10',
        'border w-full flex items-center justify-between gap-1 text-body-l rounded-lg px-4 py-1.5'
      )}
    >
      <p
        className={composeClasses(
          value ? 'text-primary' : 'text-secondary',
          'text-body-l truncate max-w-[300px]'
        )}
      >
        {value ?? placeholder}
      </p>
      {isOpen ? (
        <MdOutlineExpandLess className="text-primary min-w-[24px] min-h-[24px] flex items-center justify-center" />
      ) : (
        <MdOutlineExpandMore className="text-primary min-w-[24px] min-h-[24px] flex items-center justify-center" />
      )}
    </div>
  )
}
